<template>
  <div class="text-center">
    <b-badge
v-if="status === 'checking'"
variant="secondary"
>
      Checking...
    </b-badge>

    <b-button
      v-else-if="status === true"
      v-b-tooltip.hover
      :title="filename"
      variant="info"
      size="sm"
      @click="$emit('preview')"
    >
      <feather-icon icon="ImageIcon" /> View
    </b-button>

    <b-badge
v-else
variant="danger"
>
      Missing
    </b-badge>
  </div>
</template>

<script>
import { BBadge, BButton, VBTooltip } from 'bootstrap-vue'
import axios from 'axios'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: { BBadge, BButton },
  directives: { 'b-tooltip': VBTooltip },
  props: ['filename'],
  data() {
    return { status: 'checking' }
  },
  watch: {
    filename: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.runCheck(newVal)
        }
      },
    },
  },
  methods: {
    async runCheck(name) {
      this.status = 'checking'
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          { ObjectName: name },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.$cookies.get('userToken')}`,
            },
          },
        )
        this.status = response.data.Status === 1
      } catch {
        this.status = false
      }
    },
  },
}
</script>